module.exports = __webpack_public_path__ + "static/media/logo impian studio.80cae61a.png";